import React, { useEffect, useState } from "react";

import { Backtotop, Underline } from "../../widgets";
import EventCard from "../../components/Event_card/EventCard";
import programmes from "../../constants/programmes";
import "./Programs_organized.css";

const Programs_organized = () => {
  const [filterMonth, setFilterMonth] = useState(null);

  useEffect(() => {
    document.title = "ACCET-programme";
  }, []);

 
  const getMonthShort = (dateValue) => {
    if (!dateValue) return null;

    const numbers = dateValue.match(/\d+/g);
    if (!numbers || numbers.length < 2) return null;

    let monthNum;

    if (numbers[0].length === 4) {
      monthNum = numbers[1]; 
    } else {
      monthNum = numbers[1]; 
    }

    const months = [
      "JAN", "FEB", "MAR", "APR", "MAY", "JUN",
      "JUL", "AUG", "SEP", "OCT", "NOV", "DEC",
    ];

    return months[parseInt(monthNum, 10) - 1] || null;
  };

  
  const filteredProgrammes = programmes.filter((event) => {
    if (!filterMonth) return true;
    return getMonthShort(event.date) === filterMonth;
  });

  const months = [
    "JAN", "FEB", "MAR", "APR", "MAY", "JUN",
    "JUL", "AUG", "SEP", "OCT", "NOV", "DEC",
  ];

  return (
    <div className="programme">
      <Underline heading="IQAC - Programmes" />

     
      <div className="month-bar">
        <button
          className={!filterMonth ? "active" : ""}
          onClick={() => setFilterMonth(null)}
        >
          ALL
        </button>

        {months.map((month) => (
          <button
            key={month}
            className={filterMonth === month ? "active" : ""}
            onClick={() => setFilterMonth(month)}
          >
            {month}
          </button>
        ))}
      </div>

      <section className="programmedark">
        
          <div className={ filteredProgrammes.length === 1 ? "events-grid single-card-wrapper" : "events-grid"}>
          {filteredProgrammes.length === 0 ? (
            <p className="month_no_events">No events found</p>
          ) : (
            filteredProgrammes.map((event, idx) => (
              <EventCard key={idx} event={event} index={idx} />
            ))
          )}
        </div>
      </section>

      <Backtotop />
    </div>
  );
};

export default Programs_organized;
